import httpClient from './httpClient';
const API_PREFIX = 'pr/v3/admin';
const ALIMTALK_API_PREFIX = 'pr/alimtalk';

export default {
  getListByAdAccountId(adAccountId) {
    return httpClient.get(`${API_PREFIX}/ad-accounts/${adAccountId}/pregs`)
  },
  getPregFileListByAdAccountId(adAccountId, offset = 0, size = 50) {
    return httpClient.get(`${API_PREFIX}/ad-accounts/${adAccountId}/pregs-file`, {
      params: {
        offset: offset, limit: size
      }
    })
  },
  getPregById (campaignId, pregId) {
    return httpClient.get(`${API_PREFIX}/campaigns/${campaignId}/pregs/${pregId}`);
  },
  getPregsPage(limit = 500) {
    return httpClient.get(`${API_PREFIX}/pregs-page`,
                          {
                            params: {
                              limit: limit
                            }
                          });
  },
  getCodes() {
    return httpClient.get(`${API_PREFIX}/codes`)
  },
  chkTalkChannelIdValidation(profileId) {
    return httpClient.post(`${API_PREFIX}/talkchannel/profileid`, profileId.trim());
  },
  chkEmoticonValidation(etcInfo, adAccountId, campaignId, pregName) {
    return httpClient.post(`${API_PREFIX}/emoticon`, {
      adAccountId: adAccountId,
      etcInfo: etcInfo,
      gapCampaignId: campaignId,
      name: pregName
    })
  },
  chkDupPermaUri (permaUri) {
    return httpClient.get(`${API_PREFIX}/permauri/${permaUri}`)
  },
  registerPreg(gapAdAccountId, preg) {
    return httpClient.post(`${API_PREFIX}/ad-accounts/${gapAdAccountId}/pregs`, preg)
  },
  modifyPreg(gapCampaignId, preg) {
    console.log(preg)
    return httpClient.put(`${API_PREFIX}/campaigns/${gapCampaignId}/pregs`, preg)
  },
  modifyPregTemp(gapCampaignId, preg) {
    return httpClient.put(`${API_PREFIX}/campaigns/${gapCampaignId}/pregs/temp`, preg)
  },
  getPregByCampaignId(gapCampaignId) {
    return httpClient.get(`${API_PREFIX}/campaigns/${gapCampaignId}/preg`)

  },
  getPregUserInfo(pregUserDto) {
    return httpClient.get(`${API_PREFIX}/booker?menu-code=RV-VIEW`, {params: pregUserDto})
  },
  deletePregUser(accountId, campaignId, pregMasterId, permaUri) {
    return httpClient.post(`${API_PREFIX}/cancel?menu-code=RV-CANCEL&account-id=${accountId}&campaign-id=${campaignId}`, {
      accountId: accountId,
      pregMasterId: pregMasterId,
      permaUri: permaUri
    })
  },
  requestReward(accountId, pregMasterId) {
    return httpClient.post(`${API_PREFIX}/reward`, {
      accountId: accountId,
      pregMasterId: pregMasterId
    })
  },

  // 임시 코드
  getAppByAppId(appId) {
    const TEMP_API_PREFIX = "admaster/v1";

    return httpClient.get(`${TEMP_API_PREFIX}/apps/${appId}`)
  },
  updateShowTime(gapCampaignId, pregMasterId, pregMasterMarketInfoList) {
    return httpClient.put(`${API_PREFIX}/campaigns/${gapCampaignId}/showtime`, {
      gapCampaignId: gapCampaignId,
      pregMasterId: pregMasterId,
      pregMasterMarketInfoList: pregMasterMarketInfoList
    })
  },
  //alimtalk
  getAlimtalkRequestStatusById(gapCampaignId, pregMasterId, requestId) {
    return httpClient.get(`${ALIMTALK_API_PREFIX}/campaigns/${gapCampaignId}/request/${requestId}/status`, {
      params: {
        pregMasterId: pregMasterId
      }
    })
  },
  getAlimtalkUserLog(pregMasterId, requestId, accountId, sendingKey) {
    return httpClient.get(`${ALIMTALK_API_PREFIX}/booker`, {
      params: {
        pregMasterId: pregMasterId, requestId: requestId, accountId: accountId, sendingKey: sendingKey
      }
    })
  },
  getAlimtalkTemplates() {
    return httpClient.get(`${ALIMTALK_API_PREFIX}/templates`)
  },

  getAlimtalkRequests(gapCampaignId, pregMasterId) {
    return httpClient.get(`${ALIMTALK_API_PREFIX}/campaigns/${gapCampaignId}/request`, {
      params: {
        pregMasterId: pregMasterId
      }
    })
  },
  getTotalAlimtalkRequests(month) {
    return httpClient.get(`${ALIMTALK_API_PREFIX}/requests`, {
      params: {
        month: month
      }
    })
  },
  getAlimtalkRequestById(gapCampaignId, pregMasterId, requestId) {
    return httpClient.get(`${ALIMTALK_API_PREFIX}/campaigns/${gapCampaignId}/request/${requestId}`, {
      params: {
        pregMasterId: pregMasterId
      }
    })
  },
  getAlimtalkRequestResult(gapCampaignId, pregMasterId, requestId) {
    return httpClient.get(`${ALIMTALK_API_PREFIX}/campaigns/${gapCampaignId}/request/${requestId}/result`, {
      params: {
        pregMasterId: pregMasterId
      }
    })
  },

  registerAlimtalkRequest(campaignId, alimtalkDto) {
    return httpClient.post(`${ALIMTALK_API_PREFIX}/campaigns/${campaignId}/request`, alimtalkDto)
  },

  modifyAlimtalkRequest(campaignId, alimtalkDto) {
    return httpClient.put(`${ALIMTALK_API_PREFIX}/campaigns/${campaignId}/request`, alimtalkDto)
  },

  modifyAlimtalkScheduledTime(campaignId, scheduledDto) {
    return httpClient.put(`${ALIMTALK_API_PREFIX}/campaigns/${campaignId}/scheduled`, scheduledDto)
  },

  sendAlimtalkTestMsg(gapCampaignId, pregMasterId, requestId, accountId) {
    return httpClient.post(`${ALIMTALK_API_PREFIX}/campaigns/${gapCampaignId}/request/${requestId}/test`, {
      pregMasterId: pregMasterId,
      requestTps: 1,
      accountId: accountId,
      alimtalkRequestId: requestId,
    })
  },
  requestAlimtalkSendingJob(gapCampaignId, pregMasterId, requestId, requestTps, menuCode) {
    return httpClient.post(`${ALIMTALK_API_PREFIX}/campaigns/${gapCampaignId}/request/${requestId}/send?menu-code=${menuCode}`, {
      pregMasterId: pregMasterId,
      requestTps: requestTps,
      alimtalkRequestId: requestId,
      accountId: 0,
    })
  },
  stopAlimtalkRequestById(gapCampaignId, pregMasterId, requestId) {
    return httpClient.get(`${ALIMTALK_API_PREFIX}/campaigns/${gapCampaignId}/request/${requestId}/stop?menu-code=PR-HOLD-RA`, {
      params: {
        pregMasterId: pregMasterId
      }
    })
  },


  // batch file
  requestCompletionFile(gapCampaignId, pregMasterId, startTime, endTime, adminUserId) {
    return httpClient.post(`${API_PREFIX}/campaigns/${gapCampaignId}/completionfile`, {
      pregMasterId: pregMasterId,
      startTime: startTime,
      endTime: endTime,
      adminUserId: adminUserId
    })
  },
  requestInvitationFile(gapCampaignId, pregMasterId, startTime, endTime, adminUserId) {
    return httpClient.post(`${API_PREFIX}/campaigns/${gapCampaignId}/invitationfile`, {
      pregMasterId: pregMasterId,
      startTime: startTime,
      endTime: endTime,
      adminUserId: adminUserId
    })
  },
  requestActiveRewardStatus(gapCampaignId, pregMasterId) {
    return httpClient.post(`${API_PREFIX}/campaigns/${gapCampaignId}/emoticonbudget`, {
      pregMasterId: pregMasterId
    })
  },

  requestSendDrawReward(params) {
    return httpClient.post(`${API_PREFIX}/send-reward`, params)
  },


  getPregBisData(adAccountId){
    return httpClient.get(`${API_PREFIX}/ad-accounts/${adAccountId}/pregbis`)
  },
  getPregTotalCount(pregMasterId){
    return httpClient.get(`${API_PREFIX}/pregs/${pregMasterId}/count`)
  },

  getRegisterPregPath(gapAdAccountId) {
    return `/${API_PREFIX}/ad-accounts/${gapAdAccountId}/pregs`
  },
  getModifyPregPath(gapCampaignId) {
    return`/${API_PREFIX}/campaigns/${gapCampaignId}/pregs`
  },
  getRegisterAlimtalkPath(campaignId) {
    return `/${ALIMTALK_API_PREFIX}/campaigns/${campaignId}/request`
  },
  getModifyAlimtalkPath(campaignId) {
    return `/${ALIMTALK_API_PREFIX}/campaigns/${campaignId}/request`
  },

  // 지표
  getPregIndicator(campaignId, pregMasterId, interval, startDate, endDate) {
    return httpClient.get(`${API_PREFIX}/campaigns/${campaignId}/pregs/${pregMasterId}/stat`,{
      params: {
        starDt: startDate,
        endDt: endDate,
        interval: interval?interval:'1d'
      }
    })
  },
  setPregStatCode(gapCampaignId, statCodeList) {
    return httpClient.post(`${API_PREFIX}/campaigns/${gapCampaignId}/statcode`, {
      statRtcCodeList: statCodeList
    })
  },
  getPregStatCode(campaignId) {
    return httpClient.get(`${API_PREFIX}/campaigns/${campaignId}/statcode`)
  },
  getPregResult(gapCampaignId, pregMasterId, interval, startDate, endDate) {
    return httpClient.get(`${API_PREFIX}/campaigns/${gapCampaignId}/pregs/${pregMasterId}/finish`,{
      params: {
        starDt: startDate,
        endDt: endDate,
        interval: interval?interval:'1d'
      }
    })
  },

  // 쿠폰
  getCouponRemainingCnt(gapCampaignId, pregMasterId) {
    return httpClient.get(`${API_PREFIX}/campaigns/${gapCampaignId}/pregs/${pregMasterId}/coupon`)
  },

  // 픽셀
  updateFixels(campaignId, pixelDto) {
    return httpClient.put(`${API_PREFIX}/campaigns/${campaignId}/fixel`, pixelDto);
  },

  // 닉네임 선점 이벤트 정보
  getNicknameEvent(campaignId) {
    return httpClient.get(`${API_PREFIX}/campaigns/${campaignId}/preg-event/nickname`)
  },
  saveNicknameEvent(campaignId, nicknameEvent, alimtalkReqeust) {
    return httpClient.post(`${API_PREFIX}/campaigns/${campaignId}/preg-event/nickname`, {
      alimtalkRequestPostRequest: alimtalkReqeust,
      nicknameEvent: nicknameEvent,
    })
  },
  updateNicknameEvent(campaignId, nicknameEvent, alimtalkReqeust) {
    return httpClient.put(`${API_PREFIX}/campaigns/${campaignId}/preg-event/nickname`, {
      alimtalkRequestPostRequest: alimtalkReqeust,
      nicknameEvent: nicknameEvent,
    })
  },
  // 초대랭킹전 이벤트 정보
  getRankingEvent(gapAdAccountId) {
    return httpClient.get(`${API_PREFIX}/ad-accounts/${gapAdAccountId}/preg-event/ranking`)
  },
  // 초대랭킹전 이벤트 정보
  getRankingEventByPregMasterId(gapAdAccountId, pregMasterId) {
    return httpClient.get(`${API_PREFIX}/ad-accounts/${gapAdAccountId}/preg-event/ranking/${pregMasterId}`)
  },
  saveRankingEvent(gapAdAccountId, data) {
    return httpClient.post(`${API_PREFIX}/ad-accounts/${gapAdAccountId}/preg-event/ranking`, data)
  },
  searchRankingHistory(gapAdAccountId, pregMasterId, accountId, type) {
    return httpClient.get(`${API_PREFIX}/ad-accounts/${gapAdAccountId}/preg-event/ranking/${pregMasterId}/history`, {
      params: {
        accountId: accountId,
        type: type
      }
    })
  },
  // 초대 랭킹전 지표
  searchRankingStatistics(gapAdAccountId, pregMasterId, type) {
    return httpClient.get(`${API_PREFIX}/ad-accounts/${gapAdAccountId}/preg-event/ranking/${pregMasterId}/statistics`, {
      params: {
        'type': type
      }
    })
  },
}

